/**
 * @param {Function} condition
 * @param {Object} headers
 * @param {AxiosAdapter} prevAdapter
 * @returns {AxiosAdapter}
 */
const conditionalHeaders = (condition, headers) => prevAdapter => config => {
    if (condition()) {
      return prevAdapter({...config, headers: {
        ...config.headers,
        ...headers
      }});
    }

    return prevAdapter(config);
  };

export default conditionalHeaders;
